"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'trainer.instructions.title': 'LLM Trainer Instructions',
    'trainer.instructions.subtitle': 'Follow these steps to train your custom language model',
    'trainer.instructions.overview': 'Overview',
    'trainer.instructions.overview.text': 'This tool helps you fine-tune large language models using your own training data. The process involves four main steps:',
    'trainer.instructions.step.upload': 'Provide training examples in CSV format',
    'trainer.instructions.step.config': 'Set model parameters and training options',
    'trainer.instructions.step.monitor': 'Watch your model train in real-time',
    'trainer.instructions.step.review': 'Evaluate and deploy your trained model',
    'trainer.instructions.data.requirements': 'Data Requirements',
    'trainer.instructions.csv.format': 'CSV Format Required',
    'trainer.instructions.csv.text': 'Your training data must be in CSV format with these columns:',
    'trainer.instructions.csv.input': 'The prompt/question text (required)',
    'trainer.instructions.csv.output': 'The expected response/answer (required)',
    'trainer.instructions.csv.category': 'Classification category (optional)',
    'trainer.instructions.example.csv': 'Example CSV Data:',
    'trainer.instructions.copy': 'Copy',
    'trainer.instructions.backend.format': 'Backend Data Format',
    'trainer.instructions.jsonl.format': 'JSONL Conversational Format',
    'trainer.instructions.jsonl.text': 'Your CSV data will be automatically converted to JSONL format for fine-tuning:',
    'trainer.instructions.jsonl.example': 'Generated JSONL Format:',
    'trainer.instructions.format.notes': 'Format Notes:',
    'trainer.instructions.format.note1': 'Each line contains a complete conversation with system, user, and assistant messages',
    'trainer.instructions.format.note2': 'System prompt helps establish the model\'s behavior',
    'trainer.instructions.format.note3': 'User message contains your input data',
    'trainer.instructions.format.note4': 'Assistant message contains your expected output',
    'trainer.instructions.best.practices': 'Best Practices',
    'trainer.instructions.data.quality': 'Data Quality',
    'trainer.instructions.quality.tip1': 'Use at least 50-100 high-quality examples',
    'trainer.instructions.quality.tip2': 'Ensure consistent formatting and style',
    'trainer.instructions.quality.tip3': 'Avoid duplicate or contradictory examples',
    'trainer.instructions.quality.tip4': 'Include diverse examples covering your use case',
    'trainer.instructions.training.config': 'Training Configuration',
    'trainer.instructions.config.tip1': 'Start with 3-5 epochs for initial testing',
    'trainer.instructions.config.tip2': 'Use learning rate 0.0001 for most cases',
    'trainer.instructions.config.tip3': 'Set validation split to 20% for monitoring',
    'trainer.instructions.config.tip4': 'Choose meaningful model names',
    'trainer.instructions.model.selection': 'Model Selection',
    'trainer.instructions.selection.tip1': 'Use instruction models for conversational tasks',
    'trainer.instructions.selection.tip2': 'Start with smaller models (8B) for testing',
    'trainer.instructions.selection.tip3': 'Consider larger models (70B) for complex tasks',
    'trainer.instructions.selection.tip4': 'Enable LoRA fine-tuning for efficiency',
    'trainer.instructions.monitoring': 'Monitoring',
    'trainer.instructions.monitor.tip1': 'Watch loss values decrease over time',
    'trainer.instructions.monitor.tip2': 'Monitor validation metrics for overfitting',
    'trainer.instructions.monitor.tip3': 'Stop early if validation loss increases',
    'trainer.instructions.monitor.tip4': 'Test your model thoroughly after training',
    'trainer.instructions.troubleshooting': 'Troubleshooting',
    'trainer.instructions.trouble.upload': 'File Upload Fails',
    'trainer.instructions.upload.fix1': 'Check that your file is in CSV format',
    'trainer.instructions.upload.fix2': 'Ensure required columns (input, output) are present',
    'trainer.instructions.upload.fix3': 'Verify CSV is properly formatted with headers',
    'trainer.instructions.upload.fix4': 'Try smaller file sizes (under 10MB)',
    'trainer.instructions.trouble.validation': 'Validation Errors',
    'trainer.instructions.validation.fix1': 'Check for empty input or output fields',
    'trainer.instructions.validation.fix2': 'Remove or fix malformed CSV rows',
    'trainer.instructions.validation.fix3': 'Ensure consistent column structure',
    'trainer.instructions.validation.fix4': 'Verify special characters are properly escaped',
    'trainer.instructions.trouble.slow': 'Training Too Slow',
    'trainer.instructions.slow.fix1': 'Reduce the number of epochs',
    'trainer.instructions.slow.fix2': 'Use smaller batch sizes',
    'trainer.instructions.slow.fix3': 'Choose a smaller base model',
    'trainer.instructions.slow.fix4': 'Enable LoRA fine-tuning',
    'trainer.instructions.trouble.performance': 'Poor Model Performance',
    'trainer.instructions.performance.fix1': 'Increase training data quantity',
    'trainer.instructions.performance.fix2': 'Improve data quality and consistency',
    'trainer.instructions.performance.fix3': 'Adjust learning rate (try 0.00001)',
    'trainer.instructions.performance.fix4': 'Train for more epochs',
    'trainer.instructions.ready': 'Ready to Start?',
    'trainer.instructions.ready.text': 'Once you understand the requirements:',
    'trainer.instructions.ready.step1': 'Prepare your CSV file with input/output pairs',
    'trainer.instructions.ready.step2': 'Click the "Upload Data" tab above to begin',
    'trainer.instructions.ready.step3': 'Follow the guided workflow through each step',
    'trainer.instructions.ready.step4': 'Monitor your training progress',
    'trainer.instructions.ready.step5': 'Test and deploy your trained model',
    'trainer.instructions.good.luck': 'Good luck with your model training! 🎉',
};
